import { Truck } from "lucide-react";
import { useSettings } from "../hooks/useSettings";

const FreeDeliveryBanner = ({
  variant = "default",
  currentAmount = 0,
  showProgress = false,
  className = "",
}) => {
  const { getFreeDeliveryThreshold } = useSettings();
  const freeDeliveryThreshold = getFreeDeliveryThreshold();

  // Check if offer is still valid (till Dec 31, 2025)
  const offerEndDate = new Date("2025-12-31T23:59:59");
  const currentDate = new Date();
  const isOfferValid = currentDate <= offerEndDate;

  if (!isOfferValid) {
    return null;
  }

  const remainingAmount = Math.max(0, freeDeliveryThreshold - currentAmount);
  const hasEarnedFreeDelivery = currentAmount >= freeDeliveryThreshold;

  // Homepage banner variant
  if (variant === "homepage") {
    return (
      <section
        className={`py-4 bg-gradient-to-r from-green-500 to-emerald-600 ${className}`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-white font-bold text-lg sm:text-xl mb-1">
              🎉 Special Offer: FREE Delivery on Orders ≥ ₹
              {freeDeliveryThreshold}! 🎉
            </p>
            <p className="text-white/90 text-sm">
              Valid till December 31, 2025 • Shop now and save on delivery!
            </p>
          </div>
        </div>
      </section>
    );
  }

  // Shop page banner variant
  if (variant === "shop") {
    return (
      <div
        className={`bg-gradient-to-r from-green-500 to-emerald-600 p-4 rounded-lg mb-6 ${className}`}
      >
        <div className="text-center">
          <p className="text-white font-bold text-sm sm:text-base">
            🎉 FREE Delivery on Orders ≥ ₹{freeDeliveryThreshold} • Valid till
            Dec 31, 2025 🎉
          </p>
        </div>
      </div>
    );
  }

  // Product detail page variant
  if (variant === "product") {
    return (
      <li className={className}>
        • Free delivery on orders above ₹{freeDeliveryThreshold}
      </li>
    );
  }

  // Order form progress variant
  if (variant === "order-progress" && showProgress) {
    return (
      <div
        className={`mt-4 p-3 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-400 rounded-lg ${className}`}
      >
        <div className="flex items-start space-x-2">
          <Truck className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-bold text-green-700">
              🎉 Special Offer - Valid till Dec 31, 2025
            </p>
            <p className="text-xs text-green-600 mt-1">
              {hasEarnedFreeDelivery
                ? "✓ You got FREE delivery on this order!"
                : `Add ₹${remainingAmount.toFixed(
                    0
                  )} more to get FREE delivery!`}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Default banner variant
  return (
    <div
      className={`bg-gradient-to-r from-green-500 to-emerald-600 p-3 rounded-lg ${className}`}
    >
      <div className="flex items-center justify-center space-x-2 text-white">
        <Truck className="h-4 w-4" />
        <span className="text-sm font-medium">
          FREE Delivery on Orders ≥ ₹{freeDeliveryThreshold}
        </span>
      </div>
    </div>
  );
};

export default FreeDeliveryBanner;
